import { useState, useEffect, React } from 'react'
import { redirect, useNavigate } from 'react-router-dom'

// utils
import { useAxios } from '../../utils/useAxios'

// globals
import * as constants from '../../globals/constants'

export default function AgentPOS() {
  const navigate = useNavigate()
  const { fetchData, loading, data, error } = useAxios()
  const [page, setPage] = useState('') //redirect할 페이지
  const [loginId, setLoginId] = useState('') //로그인 아이디
  const [orderNum, setOrderNum] = useState('') //주문 번호
  const [logId, setLogId] = useState('') //url parameter 로그에 저장한 id값 받기

  useEffect(() => {
    const existingUser = JSON.parse(localStorage.getItem('user'))
    if (existingUser) {
      localStorage.removeItem('user')
      localStorage.removeItem('isNewNotice')
      localStorage.removeItem('happyorderYn')
      localStorage.removeItem('closedDay')
      localStorage.removeItem('shopHoursStart')
      localStorage.removeItem('shopHoursEnd')
      localStorage.removeItem('sessionAlert')
    }
    const queryParameters = new URLSearchParams(window.location.search)

    setOrderNum(queryParameters.get('orderNum'))
    setLoginId(queryParameters.get('loginId'))
    setPage(queryParameters.get('page'))
    setLogId(queryParameters.get('logId'))

    const params = {
      loginId: queryParameters.get('loginId'),
    }
    //사용자 정보 가저오기
    if (params.loginId) {
      fetchData(
        constants.API.GET_MEMBER, // url
        'GET', // method
        null, // body
        params, // params
      )
    }
  }, [])

  //페이지 이동 (redirect) 로그 저장
  const setPageHistoryLog = (paramPage) => {
    const params = {
      logId: logId,
      page: paramPage,
    }
    if (logId) {
      fetchData(
        constants.API.PAGE_REDIRECT_LOG, // url
        'GET', // method
        null, // body
        params, // params
      )
    }
  }

  useEffect(() => {
    if (data) {
      const resultCode = data.responseCode
      const loginInfo = data.responseData

      if (loginInfo) {
        localStorage.setItem('user', JSON.stringify(loginInfo))
        //약관동의 여부 확인
        if (loginInfo.agreementTermsYn == 'Y') {
          if (orderNum) {
            setPageHistoryLog('todayOrderList')

            navigate(`/todayOrderList`, {
              replace: true,
              state: {
                orderNum: orderNum,
                logId: logId,
              },
            })
            window.location.reload()
          } else {
            setPageHistoryLog(page)
            navigate(`/${page}`)
            window.location.reload()
          }
        } else {
          setPageHistoryLog('useguide')
          navigate('/useguide', {
            replace: true,
            state: {
              isTerms: true,
            },
          })
        }
      } else {
        setPageHistoryLog('signin')
        navigate('/signin')
      }
    }
  }, [data])

  useEffect(() => {
    if (error) {
      navigate('/signin')
    }
  }, [error])
  return <></>
}
